export default function ($translate, $rootScope) {
    const result = {
        KEYS: {
            ET: 'ET',
            EN: 'EN',
            RU: 'RU',
            LV: 'LV',
            LT: 'LT',
            NO: 'NO',
            FI: 'FI',
            SV: 'SV'
        },
        LABELS: {
            ET: $translate.instant('enums.Estonian'),
            EN: $translate.instant('enums.English'),
            RU: $translate.instant('enums.Russian'),
            LV: $translate.instant('enums.Latvian'),
            LT: $translate.instant('enums.Lithuanian'),
            NO: $translate.instant('enums.Norwegian'),
            FI: $translate.instant('enums.Finnish'),
            SV: $translate.instant('enums.Swedish')
        },
        DROPDOWN_LABELS_IN_NATIVE: {
            ET: $translate.instant('translation.dropdown.Estonian'),
            EN: $translate.instant('translation.dropdown.English'),
            RU: $translate.instant('translation.dropdown.Russian'),
            LV: $translate.instant('translation.dropdown.Latvian'),
            LT: $translate.instant('translation.dropdown.Lithuanian'),
            NO: $translate.instant('translation.dropdown.Norwegian'),
            FI: $translate.instant('translation.dropdown.Finnish'),
            SV: $translate.instant('translation.dropdown.Swedish')
        }
    };
    // TODO: Figure out how to do this correctly or move it to central component that covers all enums
    $rootScope.$on('$translateChangeSuccess', () => {
        result.LABELS = {
            ET: $translate.instant('enums.Estonian'),
            EN: $translate.instant('enums.English'),
            RU: $translate.instant('enums.Russian'),
            LV: $translate.instant('enums.Latvian'),
            LT: $translate.instant('enums.Lithuanian'),
            NO: $translate.instant('enums.Norwegian'),
            FI: $translate.instant('enums.Finnish'),
            SV: $translate.instant('enums.Swedish')
        };

        result.DROPDOWN_LABELS_IN_NATIVE = {
            ET: $translate.instant('translation.dropdown.Estonian'),
            EN: $translate.instant('translation.dropdown.English'),
            RU: $translate.instant('translation.dropdown.Russian'),
            LV: $translate.instant('translation.dropdown.Latvian'),
            LT: $translate.instant('translation.dropdown.Lithuanian'),
            NO: $translate.instant('translation.dropdown.Norwegian'),
            FI: $translate.instant('translation.dropdown.Finnish'),
            SV: $translate.instant('translation.dropdown.Swedish')
        };
    });
    return result;
}



// WEBPACK FOOTER //
// ./src/app/enums/company/language/index.js